


































import { Component } from 'vue-property-decorator';
import { AbstractProductWidget } from '@/views/product/widgets/AbstractProductWidget';
import { getModule } from 'vuex-module-decorators';
import SearchBarStore from '@/stores/search/searchBar.store';
import ProductImage from '@/views/product/common/ProductImage.vue';
import ProductTitle from '@/views/product/common/ProductTitle.vue';
import Routes from '@/util/Routes';
import { Urls } from '@/util/Urls';
import OfferBadge from '@/views/product/common/OfferBadge.vue';

@Component({
  components: {
    ProductImage,
    ProductTitle,
    OfferBadge,
  },
})
export default class CompletionProduct extends AbstractProductWidget {
  private searchBarStore = getModule(SearchBarStore, this.$store);

  public hideSearchSuggestions() {
    this.searchBarStore.setSearchBarActive(false);
  }

  public goToDetailPage() {
    this.hideSearchSuggestions();
    this.$router.push({
      name: Routes.ProductDetail,
      params: {
        sku: this.product.product.sku,
        unitAbbreviation: this.product.unit.abbreviation,
        urlName: Urls.toLinkFriendlyString(this.product.product.name),
      },
    });
  }
}
